
import { defineComponent } from 'vue'
import InstallAutofixMixin from '~/mixins/installAutofixMixin'
import OwnerDetailMixin from '~/mixins/ownerDetailMixin'
import ActiveUserMixin from '~/mixins/activeUserMixin'

export default defineComponent({
  name: 'InstallAutofixForAutoOnboard',
  mixins: [InstallAutofixMixin, OwnerDetailMixin, ActiveUserMixin],

  method: {
    async finish(): Promise<void> {
      if (this.failTimeout) clearTimeout(this.failTimeout)
      if (this.popUpTimer) clearInterval(this.popUpTimer)
      if (this.pollTimer) clearInterval(this.pollTimer)
      this.$socket.$off('autofix-installation-complete')
      this.$emit('refetch')

      this.installing = false
    }
  }
})
